module.exports = __webpack_public_path__ + "static/media/maki_forel.00beed9c.webp";